'use client';

import { createContext } from 'react';
import { noop } from 'utils/noop';
import type { ToastOptions } from './ToastTypes';

/**
 * When initializing the toast item context, the default duration is set to `null`
 */
const defaultContext: Required<Pick<ToastOptions, 'duration'>> & {
  onDismiss: () => void;
} = {
  duration: null,
  onDismiss: noop,
};

export const ToastItemContext = createContext(defaultContext);
